import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import LandingBannerOMR from '../../asset/LandingBannerOMR.jpg'
import VirtualMobileHero from '../../asset/VirtualMobileHero.webp'
import gsap from 'gsap';
import { BookingForm } from '../ui/BookingForm';

export const VirtualHeroPerungudi = () => {
  const location = useLocation();
  const blinkTextRef = useRef(null);

  useEffect(() => {
    if (blinkTextRef.current) {
      gsap.to(blinkTextRef.current, {
        opacity: 0,
        duration: 1,
        repeat: -1,
        yoyo: true,
        ease: "power1.inOut"
      });
    }
  }, []);

  // Adjust margin based on whether banner is shown (not on FreeDayPass page)

  return (
    <section style={{
      backgroundImage: window.innerWidth >= 768 ? `url(${LandingBannerOMR})` : `url(${VirtualMobileHero})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      width: '100vw',
      height: window.innerWidth >= 768 ? 'calc(100vh - 65px)' : 'auto',
    }}
      className="w-full mt-[55px] sm:mt-[65px] relative flex items-center justify-between bg-white pt-[60px] sm:pt-[100px] pb-[30px] sm:pb-[50px] px-4 sm:px-8 lg:px-[65px] max-md:flex-col max-md:h-auto max-md:gap-6 sm:max-md:gap-10">
      <div className="w-full sm:w-[55%] max-w-[700px] h-auto sm:h-full relative h-[90%] flex flex-col justify-around items-center sm:h-auto sm:flex-none sm:items-start">
        <div className="relative mb-4">
          <h1 className="text-3xl sm:text-5xl md:text-[64px] lg:text-[90px] font-bold leading-tight sm:leading-[55px] md:leading-[70px] lg:leading-[100.28px] font-regrade">
            <p className="text-[#ffffff] font-regrade text-4xl sm:text-6xl pb-2 sm:pb-4">Get A Premium</p>
            <p className="text-[#ffffff] font-regrade text-4xl sm:text-6xl pb-2 sm:pb-4">Chennai Address</p>
            <p className="text-[#f2b552] font-regrade text-2xl sm:text-3xl pb-2 sm:pb-4">Without Renting an Office</p>
          </h1>
        </div>

        <p className="text-[#e1e1e1] text-center sm:text-left text-sm sm:text-lg font-medium leading-[22px] sm:leading-[32.4px] mb-4">
          Establish your business presence remotely <br/>with a verified virtual office, mail support<br/> and professional reception services.
        </p>

        <div className="w-full flex flex-col sm:flex-row items-center gap-4 sm:gap-0">
          {/* <Button
            style={{ borderRadius: '30px' }}
            className="text-sm sm:text-[15px] text-white rounded-[30px] mr-0 sm:mr-8 px-5 hover:bg-[#7d5262] transition-colors w-full sm:w-auto"
            onClick={scrollToBookATour}
          >
            Reserve Your Premium Address
          </Button> */}
          <p className="text-sm text-white sm:text-[14px]">for ₹14,999/year </p>
        </div>

        <p
          className="mt-4 text-white text-sm sm:text-base"
          style={{ textShadow: '0px 0px 2px #6517179e' }}
        >
          Now Open at Perungudi <span className="text-[red]" ref={blinkTextRef}> - Limited Slots!</span>
        </p>
      </div>

      <div className="w-full sm:w-[45%] mt-10 sm:mt-0">
        <BookingForm />
      </div>

    </section>
  );
};
